import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { clone, map, filter } from "lodash";
import { Card, CardBody, CardTitle,CardHeader } from 'reactstrap';
import Modal from 'react-bootstrap4-modal';
import TextFieldGroup from "../../common/TextFieldGroup";
import { connect } from "react-redux";
import { Element, scroller } from "react-scroll";
import moment from "moment";
import { Spinner } from "../../common/Spinner/index";
import Things from "../../../ducks/Things";
import Groups from "../../../ducks/Groups";
import Select from "react-select-nested-group";
import { MapWithAMarkerClusterer } from "../../common/maps/Maps";
import pointerIcon from "../../../assets/img/ic_speedometer_grey.png";
import last_updated from "../../../assets/img/last_updated.png";
import cold_storage from "../../../assets/img/cold_storage.png";
import warehouse from "../../../assets/img/warehouse.png";
import VehicleVan from "../../../assets/img/VehicleVan.png";
import CargoVan from "../../../assets/img/CargoVan.png";
import pin_moving from "../../../assets/img/pin_moving.png";
import pin_parked from "../../../assets/img/pin_parked.png";
import editIcon from "../../../assets/img/ic_edit.png";
import { filterVehicleListing } from "../../../utils/helper.util";
import SelectComponent from "../../select";

import "./Index.css";

function radiusToZoom(distance) {
  let radius = distance / 2;
  radius = radius || 5;
  return Math.round(16 - Math.log(radius) / Math.LN2);
}



class MapView extends Component {
  constructor(props) {
    super(props);


    this.state = {
     'selectedThing': [],
     'selectedGroup': [],
     'defaultCenter': {
        lat: 30.1575,
        lng: 71.5249,
        },
      zoom: 7.5,
      loading: true,
      searchVehicleValues: [],
      'editThing':{},
      'stats':{}
    };
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.observationsfetched = this.observationsfetched.bind(this);
  }

  async componentDidMount() {

    let user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      this.props.history.push('/login');
    } else {
      this.observationsfetched();
      // setInterval(() => {
      //   this.observationsfetched();
      // }, 60000);
    }
  };

  async observationsfetched(){
    const observations = await this.props.actions.getDashboardData();
    let stats = {'total':observations.length,'online':0,'offline':0, 'disconnected':0};
    let searchVehicleValues = observations.map((item) => {
      if (item.thingStatus === "offline"){
        stats['offline'] = stats['offline'] + 1;
      } else if(item.thingStatus === "online"){
        stats['online'] = stats['online'] + 1;
      }
      else {
        stats['disconnected'] = stats['disconnected'] + 1;
      }

      return {
        value: item._id,
        label: item.thingName,
        item: item,
      }
    });

    (async () => {
      const companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
      if (!(this.props.groupList && this.props.groupList.length)) {
        this.props.groupActions.getSubGroups(companyInfo.groupId);
      }
    })();
    this.setState({...this.state,selectedThing: observations,searchVehicleValues,stats : stats,loading:false});
  }

  onCenterChanged(map) {
    this.props.actions.ChangeCenter({
      lat: map.getCenter().lat(),
      lng: map.getCenter().lng(),
    });
  };

  async handleDoubleClick(item) {
    await this.props.actions.selectedThingData(item);
     this
     .props
     .history
     .push(`/temperature/${item.imei}`);
  }

  searchVehicle = async (selectedOption) => {
    const thingId = selectedOption ? selectedOption.value : null;

    console.log("searchVehicle clicked")

    if (thingId) {
      let things = clone(this.state.selectedThing);
      console.log("things -> ", things)
      let vehicleLocation = filter(things, (item) => {
        if (item._id === thingId) return item;
      });

      console.log("vehicleLocation -> ", vehicleLocation)
      if (vehicleLocation.length) {

        this.setState({
          ...this.state,
          defaultCenter: {
            lat: vehicleLocation[0].lat,
            lng: vehicleLocation[0].lng,
          },
          defaultSearchValue: selectedOption,
          zoom: 17,
          vehicleNumberPlate: selectedOption.value,
          // selectedThing: vehicleLocation,
          todayTrack: [],
          todayEvents: {},
          todayStops: [],
          movingTracks: [],
        });
        this.props.actions.ChangeCenter({
          lat: vehicleLocation[0].lat,
          lng: vehicleLocation[0].lng,
        });

        scroller.scrollTo(thingId, {
          duration: 1500,
          smooth: true,
          containerId: "containerElement",
          offset: -120,
        });
      }
    } else {
      // this.props.actions.getSummaryWidgets();
      this.setState({
        ...this.state,
        searchTerm: "",
        defaultCenter: {
          lat: 30.1575,
          lng: 71.5249,
        },

        zoom: 5.5,
        vehicleNumberPlate: "",
        selectedVehicle: null,
        // selectedThing: null,
        defaultSearchValue: null,
      });
      this.props.actions.ChangeCenter({
        lat: 30.1575,
        lng: 71.5249,
      });
    }
  };

  selectGroup = (selectedGroup) => this.setState({ selectedGroup });

  filterVehicle = async (value) => {
    await this.setState({ ...this.state, searchValue: value });
    if (!value || (value && !value.length)) {
      this.searchVehicle({})
    }
  };

  onchangeAttachedGroup = (attachedGroup) => {
    let editThing = this.state.editThing;
    editThing['attachedGroup'] = attachedGroup
    this.setState({...this.state,editThing })
  };

  onThingNameChange = (e) => {
    let editThing = this.state.editThing;
    editThing['thingName'] = e.target.value
    this.setState({...this.state,editThing })
  };

  editThingetails(item) {
    item['attachedGroup'] = [{
     "name" : item.groupName,  "_id" : item.groupId
    }];
    this.setState({...this.state,edit:true,editThing:item})
  };

  SubmitThingOnClick = async () =>{
    let data = {
      groupId: this.state.editThing.attachedGroup[0]['value'] || this.state.editThing.attachedGroup[0]['_id'],
      name: this.state.editThing.thingName
    };
    let requestData = {
      'data':data,
      'imei':this.state.editThing.imei
    };
    await this.props.actions.updateThingData(requestData);
    this.setState({...this.state, edit : false, editThing:{}})
  };

  modalBackdropClicked = async () => {
    this.setState({...this.state, edit : false});
  }

  render() {

    let loader = <Spinner key="1" />;
  const filteredThings = filterVehicleListing(
    this.state.selectedThing,
    this.state.selectedGroup,
    map(this.state.selectedStatus, "value"),
    this.state.searchValue
  );


  console.log("this.state.defaultCenter -> ", this.state.defaultCenter)

    const {selectedThing} = this.state;
    return (
      <div>
         {this.state.loading ? ( [loader]) : (
           <>
           <Modal
             visible={this.state.edit}
             dialogClassName="driver-modal-dialog"
             >
             <div>
               <button
                 type="button"
                 className="close close-x"
                 aria-label="Close"
                 onClick={this.modalBackdropClicked}
               >
                 <span aria-hidden="true">&times;</span>
               </button>
             </div>
             <div className="modal-heading row">
               <div className="col-lg-4 col-md-4 col-sm-4">
                 {" "}
                 <p className="driver-heading">Device Update</p>
               </div>
             </div>
             <div className="modal-body">
                 <div className="row">
                   <div className="col-lg-6">
                     <TextFieldGroup
                       field={"thingName"}
                       placeholder={"Enter thingName provided to you"}
                       value={this.state.editThing.thingName || ''}
                       label={"Device Name"}
                       type={"text"}
                       onChange={this.onThingNameChange} />
                   </div>
                   <div className="col-lg-6">
                     <div className="form-group">
                         <SelectComponent
                                   field="form-field-name"
                                   placeholder="Select Group"
                                   label={"Select Group"}
                                   preSelected={this.state.editThing.attachedGroup || []}
                                   optionKeys={{ label: "name", value: "_id" }}
                                   options={this.props.groupList}
                                   onChange={this.onchangeAttachedGroup}
                                 />
                       </div>
                   </div>
                 </div>
             </div>
             <div className="modal-footer">
               <button className="close-btn" onClick={this.SubmitThingOnClick}>
                     Save
               </button>
             </div>
     </Modal>
           <div>
       <div className="row" style={{  justifyContent: "space-between"}}>
       <div className="col-md-4">
                     <SelectComponent
                       field="form-field-name"
                       placeholder="Select Group"
                       preSelected={this.state.selectedGroup}
                       multi={true}
                       optionKeys={{ label: "name", value: "_id" }}
                       options={this.props.groupList}
                       onChange={this.selectGroup}
                     />
       </div>
       <div className="col-md-4">
                   <div>
                     <div className="form-group">
                       <Select
                         name="form-field-name"
                         isClearable={true}
                         isMulti
                         isSearchable={true}
                         placeholder="Search"
                         onChange={this.filterVehicle}
                         value={this.state.searchValue}
                         options={this.state.searchVehicleValues}
                       />
                     </div>
                   </div>
                 </div>
         <div className="col-md-9 cluster-map-view">
           <MapWithAMarkerClusterer
               markers={filteredThings }
               smoothCall={false}
               zoom={this.state.zoom}
               center={{
                 lat: this.state.defaultCenter.lat,
                 lng: this.state.defaultCenter.lng,
               }}
               defaultCenter={{
                 lat: this.state.defaultCenter.lat,
                 lng: this.state.defaultCenter.lng,
               }}
               onCenterChanged={this.onCenterChanged.bind(this)}
               onVehicleClick={this.searchVehicle.bind(this)}
               defaultSearchValue={this.state.defaultSearchValue}
             />
         </div>
         <div className="col-md-3 ">
                 <div
                   className="things-listing-with-maps element m-t-20-px"
                   id="containerElement"
                 >
                   {map(filteredThings, (item) => {
                     let style = {},
                     vehicleStatus = 'VEHICLE_MOVING';
                     let status = "Parked";
                     let pinIcon = pin_parked;
                     let statusClass = "fa fa-circle circle-orange";
                     let thingStatusClass = item.thingStatus === "online" ? 'fa fa-circle circle-green' : 'fa fa-circle circle-red'
                     const engineColor ="#03ABCE";
                     let displayIcon;
                     if (item.type === "warehouse"){
                      displayIcon = warehouse;
                     } else {
                      displayIcon = CargoVan;
                     }
                     return (
                       <Element
                         className={`element section-side ${
                           this.state.vehicleNumberPlate === item._id
                             ? " selected"
                             : ""
                           }`}
                         key={item._id}
                         name={item._id}
                         onDoubleClick={() => this.handleDoubleClick(item)}
                       >
                         <p className="m-b-0">
                         <span className="m-r-10-px section-icons">
                             <img
                               className="inline-block pin-icon-list"
                               style={style}
                               src={displayIcon}
                               alt=""
                             />
                           </span>
                           <span className="textbold" onClick={this.searchVehicle.bind(this, {
                           value: item._id,
                           label: item.imei,
                           vehicle: item,
                         })}>
                             {item.thingName}
                           </span>
                           <span className="list-status pull-right">
                             <i className={thingStatusClass} />
                             {item.thingStatus === "online" ? "online" : item.thingStatus === "offline" ? "offline" :"disconnected"}
                           </span>
                           <span style={{cursor:"pointer",marginRight:" 10px"}} className="pull-right list-status" onClick={() => { this.editThingetails(item) }}>
                             <img src={editIcon} alt='' />
                           </span>
                         </p>

                         {this.state.vehicleNumberPlate === item._id && (
                           <>
                             <p className="vehicle-info">
                               <span className="section-icons">
                                 <img
                                   className="section-list-icons"
                                   src={last_updated}
                                   alt=""
                                 />
                               </span>
                               <span className="simple-txt">
                                 Last update:
                               <span>
                                   {item.timestamp
                                     ? moment(item.timestamp).format(
                                       "DD/MM/YYYY, h:mm a"
                                     )
                                     : "N/A"}
                                 </span>
                               </span>
                               
                             </p>
                             <p className="vehicle-info">
                               <span className="section-icons">
                                 <img
                                   className="section-list-icons"
                                   src={last_updated}
                                   alt=""
                                 />
                               </span>
                               <span className="simple-txt">
                                 Temperature Sensor 1:
                               <span>
                                   { item.temperature ? item.temperature : "N/A"}
                                 </span>
                               </span>
                             </p>
                             
                               {item.temperature2 && (
                                <>
                              <p className="vehicle-info">
                               <span className="section-icons">
                                 <img
                                   className="section-list-icons"
                                   src={last_updated}
                                   alt=""
                                 />
                               </span>
                                <span className="simple-txt">
                                 Temperature Sensor 2:
                               <span>
                                   { item.temperature2 ? item.temperature2 : "N/A"}
                                 </span>
                               </span>
                               </p>
                                </>
                               )}
                               {item.temperature3 && (
                                <>
                              <p className="vehicle-info">
                               <span className="section-icons">
                                 <img
                                   className="section-list-icons"
                                   src={last_updated}
                                   alt=""
                                 />
                               </span>
                                <span className="simple-txt">
                                 Temperature Sensor 3:
                               <span>
                                   { item.temperature3 ? item.temperature3 : "N/A"}
                                 </span>
                               </span>
                               </p>
                                </>
                               )}
                               {item.temperature4 && (
                                <>
                              <p className="vehicle-info">
                               <span className="section-icons">
                                 <img
                                   className="section-list-icons"
                                   src={last_updated}
                                   alt=""
                                 />
                               </span>
                                <span className="simple-txt">
                                 Temperature Sensor 4:
                               <span>
                                   { item.temperature4 ? item.temperature4 : "N/A"}
                                 </span>
                               </span>
                               </p>
                                </>
                               )}
                               
                             
                             <p className="vehicle-info">
                               <span className="section-icons">
                                 <img
                                   className="section-list-icons"
                                   src={last_updated}
                                   alt=""
                                 />
                               </span>
                               <span className="simple-txt">
                                 Humidity:
                               <span>
                                   { item.humidity ? item.humidity : "N/A"}
                                 </span>
                               </span>
                             </p>
                             {item.humidity2 && (
                              <>
                                 <p className="vehicle-info">
                               <span className="section-icons">
                                 <img
                                   className="section-list-icons"
                                   src={last_updated}
                                   alt=""
                                 />
                               </span>
                               <span className="simple-txt">
                                 Humidity sensor 2:
                               <span>
                                   { item.humidity2 ? item.humidity2 : "N/A"}
                                 </span>
                               </span>
                             </p>
                              </>
                             )}
                             {item.humidity3 && (
                              <>
                                 <p className="vehicle-info">
                               <span className="section-icons">
                                 <img
                                   className="section-list-icons"
                                   src={last_updated}
                                   alt=""
                                 />
                               </span>
                               <span className="simple-txt">
                                 Humidity sensor 3:
                               <span>
                                   { item.humidity3 ? item.humidity3 : "N/A"}
                                 </span>
                               </span>
                             </p>
                              </>
                             )}
                             {item.humidity4 && (
                              <>
                                 <p className="vehicle-info">
                               <span className="section-icons">
                                 <img
                                   className="section-list-icons"
                                   src={last_updated}
                                   alt=""
                                 />
                               </span>
                               <span className="simple-txt">
                                 Humidity sensor 4:
                               <span>
                                   { item.humidity4 ? item.humidity4 : "N/A"}
                                 </span>
                               </span>
                             </p>
                              </>
                             )}
                             
                             {
                               item.type === "vehicle" && (
                                <p className="vehicle-info">
                                  <span className="section-icons">
                                    <img
                                      className="section-list-icons"
                                      src={last_updated}
                                      alt=""
                                    />
                                  </span>
                                  <span className="simple-txt">
                                    Milage:
                                  <span>
                                      { item.milage ? item.milage + ' Km' : "N/A"}
                                    </span>
                                  </span>
                                </p>
                               )
                             }
                           </>
                         )}

                       </Element>
                     );
                   })}
                 </div>
               </div>
       </div>
       <div className="row" style={{ justifyContent : "center" }}>
        <div style={{display:"flex", width:"100%"}}>
            <div style={{flexGrow:"1"}} className="card-display">
              <Card style={{ height: "175px" ,flexDirection: "column", minWidth: "94%" }}>
              <CardHeader style={{ width: "100%", height:"50px"}} className="f-bold">Stats </CardHeader>
                <CardBody>
                  <CardTitle>
                    <div className="row" style={{ textAlign: 'center' }}>
                      <div className="col-md-3">
                        <div className="margin-top-6">
                        </div>
                        <div>
                          <span className="counter" style={{ cursor: 'pointer' }} >{this.state.stats.total}</span>
                        </div>
                        <div>
                          <span className="card-heading font-15">
                            Total
                          </span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="margin-top-6">
                        </div>
                        <div>
                          <span className="counter" style={{color : 'green'}}>{this.state.stats.online}</span>
                        </div>
                        <div>
                          <span className="card-heading font-15">
                            Online
                          </span>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="margin-top-6">
                        </div>
                        <div>
                          <span className="counter" style={{color : 'orange'}}>{this.state.stats.disconnected}</span>
                        </div>
                        <div>
                          <span className="card-heading font-15">
                            Disconnected
                          </span>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="margin-top-6">
                        </div>
                        <div>
                          <span className="counter" style={{color : 'red'}}>{this.state.stats.offline}</span>
                        </div>
                        <div>
                          <span className="card-heading font-15">
                            Offline
                          </span>
                        </div>

                      </div>

                    </div>
                  </CardTitle>
                </CardBody>
              </Card>
            </div>
          </div>
       </div>
     </div>
     </>
         )}
              
      </div>
    );
  }
}

MapView.propTypes = {};
MapView.defaultProps = {};
const mapStateToProps = (state) => {
  return {
    groupList: state.groups.subGroups,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Things.creators, dispatch),
  groupActions: bindActionCreators(Groups.creators, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(MapView);
